import { useListContext } from "react-admin";
import { Box, IconButton, MenuItem, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import isEqual from "lodash/isEqual";
import { Close } from "@mui/icons-material";

const unitChoices = [
  { id: 1, name: "seconds" },
  { id: 60, name: "minutes" },
  { id: 60 * 60, name: "hours" },
  { id: 60 * 60 * 24, name: "days" },
  { id: 60 * 60 * 24 * 30, name: "months" },
  { id: 60 * 60 * 24 * 365, name: "years" },
];

const secondsToUnit = (seconds) => {
  if (typeof seconds == "undefined") return undefined;

  if (!seconds) {
    return {
      quantity: 0,
      unit: 1,
    };
  }

  const units = [...unitChoices].reverse();

  for (const unit of units) {
    if (!(seconds % unit.id)) {
      return {
        quantity: seconds / unit.id,
        unit: unit.id,
      };
    }
  }
};

const sxSmall = { ".MuiInput-input": { padding: "0 12px" } };
const styleFielset = {
  padding: "2px 8px",
  borderRadius: "5px",
  borderStyle: "solid",
  borderWidth: "1px",
  overflow: "hidden",
  minWidth: "0%",
  borderColor: "rgba(0, 0, 0, 0.23)",
  position: "relative",
  top: "-5px",
};
const styleLegend = {
  color: "rgba(0, 0, 0, 0.6)",
  fontFamily:
    'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
  fontWeight: "400",
  fontSize: ".8rem",
  lineHeight: "1.4375em",
  padding: "0 5px",
};

const TimePeriodFilter = ({
  source,
  label,
  getValue = (filter) => filter.quantity * filter.unit || undefined,
}) => {
  const { filterValues, setFilters } = useListContext();
  const initial = secondsToUnit(filterValues?.[source]);

  // State for Quantity & Unit
  const [filter, setFilter] = useState(initial);

  // Update filters when the state changes
  useEffect(() => {
    const oldValue = filterValues[source];
    const newValue =
      typeof filter == "undefined" ? undefined : getValue(filter);
    if (oldValue == newValue) return null;

    const newFilter = {
      ...filterValues,
      [source]: newValue,
    };

    if (isEqual(filterValues, newFilter)) return null;

    setFilters(newFilter, null);
  }, [filter, source, setFilters]);

  // Handle Input Changes
  const handleChange = (key) => (event) => {
    setFilter((prev) => ({ ...prev, [key]: event.target.value }));
  };

  return (
    <fieldset style={styleFielset}>
      <legend style={styleLegend}>{label}</legend>
      <Box display="flex" gap={2} className="TimePeriodFilter">
        {/* Quantity Input */}
        <TextField
          className="TimePeriodQuantity"
          label=""
          type="number"
          value={filter ? filter.quantity : ""}
          onChange={handleChange("quantity")}
          variant="standard"
          size="small"
          sx={{ ...sxSmall, width: "70px", flexShrink: "0" }}
        />
        {/* Unit Select */}
        <TextField
          className="TimePeriodUnit"
          select
          label=""
          value={filter ? filter.unit : ""}
          onChange={handleChange("unit")}
          variant="standard"
          size="small"
          sx={sxSmall}
        >
          {unitChoices.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        <IconButton onClick={() => setFilter(undefined)}>
          <Close />
        </IconButton>
      </Box>
    </fieldset>
  );
};

export default TimePeriodFilter;
